"use strict";

const { Swiper } = await import("../swiper/swiper.js"),
	{ Autoplay } = await import("../swiper/autoplay.js");

new Swiper(".swiper-hero-slider", {
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
		},
		1280: {
			slidesPerView: 4,
		},
	},
	loop: true,
	modules: [Autoplay],
	spaceBetween: 24,
	speed: 2000,
	watchOverflow: true,
});
